import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { InvoyssLogo } from '@/features/brand/InvoyssLogo';

interface NotFoundProps {
  variant?: 'route' | 'invoice' | 'invite';
}

const COPY: Record<NonNullable<NotFoundProps['variant']>, { title: string; body: string }> = {
  route: {
    title: 'Page not found',
    body: "We couldn't find the page you were looking for. The link might be old or the page has moved.",
  },
  invoice: {
    title: 'Invoice not found',
    body: 'This invoice link looks expired, withdrawn, or never existed. If you have a question about a payment, contact the sender directly.',
  },
  invite: {
    title: 'Invite not found',
    body: 'This invite link looks expired, revoked, or already accepted. Ask whoever invited you to send a new one.',
  },
};

export function NotFoundScreen({ variant = 'route' }: NotFoundProps) {
  const copy = COPY[variant];
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-8 px-4 py-12 text-center">
      <InvoyssLogo size="lg" className="mb-8" />
      <div className="flex max-w-md flex-col gap-3">
        <p className="font-display text-[64px] font-semibold leading-none tracking-tight text-muted-foreground/60">
          404
        </p>
        <h1 className="font-display text-2xl font-semibold tracking-tight">{copy.title}</h1>
        <p className="text-sm leading-relaxed text-muted-foreground">{copy.body}</p>
      </div>
      <Button asChild variant="primary">
        <Link to="/">Back home</Link>
      </Button>
    </main>
  );
}
